import { Box, Typography } from '@mui/material';
import { styles } from '../../styles.ts';
import {
  INodeCardProps,
  OwnerType,
} from '~/modules/identification/forms/OwnershipStructure/types.ts';
import { getOwnerTypeIcon } from '~/modules/identification/forms/OwnershipStructure/utils/utils.tsx';
import { NodeCardContent } from '~/modules/identification/forms/OwnershipStructure/components/Diagram/NodeCardContent.tsx';

export const NodeCard = ({ data }: INodeCardProps) => {
  const { ownerType, ownershipPercentage, isRoot } = data;

  return (
    <Box sx={styles.cardDiagram}>
      <Box sx={isRoot ? { ...styles.cardIcon } : { ...styles.cardIcon, position: 'absolute' }}>
        {getOwnerTypeIcon(ownerType as OwnerType)}
      </Box>
      {!isRoot && ownershipPercentage != null && (
        <Typography sx={styles.cardHeader}>{ownershipPercentage}%</Typography>
      )}
      <NodeCardContent data={data} />
    </Box>
  );
};
